import React from 'react';
import { AuthPageWrapper } from 'features/authentication/auth-page-wrapper/auth-page-wrapper';
import { Heading, BodyText, MenuText, DevicesIllustration, Link } from '@placer-ui/components';
import { useQuery } from 'hooks/use-query/use-query';
import styles from './email-mfa.module.scss';

export const EmailMfa = () => {
    const email = useQuery('email')!;

    return (
        <AuthPageWrapper>
            <div className={styles.container}>
                <DevicesIllustration />
                <div className={styles.textContainer}>
                    <div className={styles.headingContainer}>
                        <Heading variant={'h2'} testId="email-mfa-welcome-back-header">
                            Welcome Back
                        </Heading>
                    </div>
                    <MenuText>
                        {`We’ve sent an email to ${email} to verify your identity.\nPlease check your inbox and click the verification link to log in.`}
                    </MenuText>
                </div>
                <BodyText element={'p'} size={'small'} color={'secondary'}>
                    Experiencing Problems? Contact{' '}
                    <Link href="mailto:support@placer.ai">support@placer.ai</Link>.
                </BodyText>
            </div>
        </AuthPageWrapper>
    );
};
